import { takeEvery, put, call } from "redux-saga/effects"
import {
  GET_USAGE_DETAILS,
  SET_USAGE_DETAILS
} from "./actionTypes"
import {
  setUsageDetails
} from "./actions"
import {
  UsageDetails,
  UsageDetailsForAllApps
} from "../../../helpers/lystface_helper"



function* watchForGetUsageDetails({ payload }) {
  try {
    const { startDate, endDate, granularity, appId } = payload
    let response;
    if (appId) {
      response = yield UsageDetails(startDate, endDate, granularity, appId)

    }
    else {
      response = yield UsageDetailsForAllApps(startDate, endDate, granularity, appId)

    }
    let data = {
      responseMessage: response?.responseMessage,
      responseStatus: response?.responseStatus,
      usageDetails: response?.responseCode ? { count: response?.response?.count, ...response.response } : {}
    }
    if (response.responseCode) {
      yield put(setUsageDetails(data))
    } else {
      console.log('errorrrrrrrrrrrr', data, response)
      yield put(setUsageDetails(data))
    }
  } catch (error) {
    yield put(setUsageDetails({ responseMessage: "There was an error fetching the usage details, please try again later!", responseStatus: "Error" }))
    console.log(error)
  }
}



function* UsageMenuSaga() {
  yield takeEvery(GET_USAGE_DETAILS, watchForGetUsageDetails)

}

export default UsageMenuSaga
